import { CaseInsensitiveMap } from "@multiweb/types/multiweb";
import { SagaWithReturnType } from "@multiweb/types/react";
import { DEFAULT_DATASOURCE_KEY, ICoreDataSourceRegistrator } from "../../core/types";

export class CoreDataSourceRegistrator implements ICoreDataSourceRegistrator {
    private _customDataSources: CaseInsensitiveMap<CaseInsensitiveMap<SagaWithReturnType<any, any>>> = new Map();

    private _getOrRegAndGet(dataSourceId: string): CaseInsensitiveMap<SagaWithReturnType<any, any>> {
        if (!this._customDataSources.has(dataSourceId)) this._customDataSources.set(dataSourceId, new CaseInsensitiveMap<SagaWithReturnType>());

        // @ts-ignore -- horni podminkou je zaruceno, ze tohle nebude nikdy undefined
        return this._customDataSources.get(dataSourceId);
    }

    private _getDataSource(dataSourceId: string, useDefaultIfNotExist: boolean = true): undefined | CaseInsensitiveMap<SagaWithReturnType<any, any>> {
        if (!this._customDataSources.has(dataSourceId)) {
            if (useDefaultIfNotExist) {
                return this._customDataSources.get(DEFAULT_DATASOURCE_KEY);
            }
            return undefined;
        } else {
            return this._customDataSources.get(dataSourceId);
        }
    }

    public registerMethodToDataSource(methodName: string, methodBody: SagaWithReturnType<any, any>, dataSourceId: string = DEFAULT_DATASOURCE_KEY): void {
        const dataSource = this._getOrRegAndGet(dataSourceId);

        if (dataSource.has(methodName)) {
            throw Error("Method has already been registered!");
        }
        dataSource.set(methodName, methodBody);
    }

    public getMethodByDataSource(methodName: string, dataSourceId: string = DEFAULT_DATASOURCE_KEY, useDefaultIfNotExist: boolean = true): SagaWithReturnType<any, any> | undefined {
        const dataSource = this._getDataSource(dataSourceId, useDefaultIfNotExist);

        if (dataSource) return dataSource.get(methodName);

        return undefined;
    }
}
